export class MouseButtonTracker {
    private _mouseDown: boolean = false;

    public track(): void {
        document.body.onmousedown = () => {
            this._mouseDown = true;
        };

        document.body.onmouseup = () => {
            this._mouseDown = false;
        };
    }
    public stopTrack(): void {
        document.body.onmousedown = null;
        document.body.onmouseup = null;
    }

    public get isMouseDown(): boolean {
        return this._mouseDown;
    }
}
